"use strict"; // Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0

var _regeneratorRuntime = require("@babel/runtime/regenerator");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decrypt = exports.encrypt = void 0;

var rxjs_1 = require("rxjs");

var util_1 = require("../util");
/**
 *
 * @param plainText string to be encrypted
 * @param secret hex representation of 32-byte secret
 * returns hex string representation of bytes in the order: initialization vector (iv),
 * auth tag, encrypted plaintext. IV is 12 bytes. Auth tag is 16 bytes. Remaining bytes are the
 * encrypted plainText.
 */


function encrypt(_x, _x2) {
  return _encrypt.apply(this, arguments);
}

function _encrypt() {
  _encrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(plainText, secret) {
    var ivBytes, secretKey, enc, encryptedResult, tagLength, authTag, encryptedPlaintext, authTagBytes, encryptedPlaintextBytes, concatted;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(secret.length !== 64)) {
              _context2.next = 2;
              break;
            }

            throw Error("secret must be 256 bits");

          case 2:
            ivBytes = crypto.getRandomValues(new Uint8Array(12));
            _context2.next = 5;
            return crypto.subtle.importKey("raw", (0, util_1.hexStringToUint8Array)(secret), {
              "name": "aes-gcm"
            }, false, ["encrypt", "decrypt"]);

          case 5:
            secretKey = _context2.sent;
            enc = new TextEncoder(); // Will return encrypted plainText with auth tag (ie MAC or checksum) appended at the end

            _context2.next = 9;
            return window.crypto.subtle.encrypt({
              name: "AES-GCM",
              iv: ivBytes
            }, secretKey, enc.encode(plainText));

          case 9:
            encryptedResult = _context2.sent;
            tagLength = 16;
            authTag = encryptedResult.slice(encryptedResult.byteLength - tagLength);
            encryptedPlaintext = encryptedResult.slice(0, encryptedResult.byteLength - tagLength);
            authTagBytes = new Uint8Array(authTag);
            encryptedPlaintextBytes = new Uint8Array(encryptedPlaintext);
            concatted = new Uint8Array([].concat(_toConsumableArray(ivBytes), _toConsumableArray(authTagBytes), _toConsumableArray(encryptedPlaintextBytes)));
            return _context2.abrupt("return", (0, util_1.uint8ArrayToHex)(concatted));

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _encrypt.apply(this, arguments);
}

exports.encrypt = encrypt;
/**
 *
 * @param cipherText hex string representation of bytes in the order: initialization vector (iv),
 * auth tag, encrypted plaintext. IV is 12 bytes. Auth tag is 16 bytes.
 * @param secret hex string representation of 32-byte secret
 */

function decrypt(cipherText, secret) {
  if (secret.length !== 64) throw Error("secret must be 256 bits");
  return new rxjs_1.Observable(function (subscriber) {
    void _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var secretKey, encrypted, ivBytes, authTagBytes, encryptedPlaintextBytes, concattedBytes, algo, decrypted, decoder;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return crypto.subtle.importKey("raw", (0, util_1.hexStringToUint8Array)(secret), {
                "name": "aes-gcm"
              }, false, ["encrypt", "decrypt"]);

            case 2:
              secretKey = _context.sent;
              encrypted = (0, util_1.hexStringToUint8Array)(cipherText);
              ivBytes = encrypted.slice(0, 12);
              authTagBytes = encrypted.slice(12, 28);
              encryptedPlaintextBytes = encrypted.slice(28);
              concattedBytes = new Uint8Array([].concat(_toConsumableArray(encryptedPlaintextBytes), _toConsumableArray(authTagBytes)));
              algo = {
                name: "AES-GCM",
                iv: new Uint8Array(ivBytes)
              };
              _context.prev = 9;
              _context.next = 12;
              return window.crypto.subtle.decrypt(algo, secretKey, concattedBytes);

            case 12:
              decrypted = _context.sent;
              decoder = new TextDecoder();
              subscriber.next(decoder.decode(decrypted));
              subscriber.complete();
              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](9);
              subscriber.error(_context.t0);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 18]]);
    }))();
  });
}

exports.decrypt = decrypt;